// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"X0-z","displaySixCardTiles":"Y0-z"};